import {
  type CleanupBinding,
  cleanupBindingConfiguration,
} from '@streamlain/database-identity';

import type {
  AutomationBlockModel,
  AutomationBlockProps,
} from '../schemas/automation-model.js';

export const DEFAULT_CLEANUP_SIZE = 240;

type CleanupBindingUpdate = Pick<
  AutomationBlockProps,
  | 'sourceTableId'
  | 'sourceDocId'
  | 'sourceTableName'
  | 'outputTables'
  | 'inputTables'
  | 'outputMode'
  | 'triggerConfig'
  | 'filterGroup'
>;

/** One selection owns both ports. Changes always return the block to paused. */
export function cleanupBindingUpdates(
  model: AutomationBlockModel,
  binding: CleanupBinding | null,
  side: 'input' | 'output',
  tableName = '',
  columns: readonly { id: string; type: string }[] = []
): CleanupBindingUpdate {
  return cleanupBindingConfiguration(
    model.store.workspace.id,
    model.props,
    binding,
    side,
    tableName,
    columns
  );
}

/** The store transaction also makes replacement/removal a single undo step. */
export function writeCleanupBinding(
  model: AutomationBlockModel,
  binding: CleanupBinding | null,
  side: 'input' | 'output',
  tableName = '',
  columns: readonly { id: string; type: string }[] = []
): CleanupBindingUpdate {
  const updates = cleanupBindingUpdates(
    model,
    binding,
    side,
    tableName,
    columns
  );
  model.store.transact(() => model.store.updateBlock(model, updates));
  return updates;
}
